import { doGetFetch, doPostFetch } from './utils/fetchUtil';
import { getPageConfigInfo } from './commonDataService';
import {
  GET_PRODUCT_DETAILS,
  POST_PRODUCT_DETAILS,
  GET_PRODUCT_INFO,
  GET_SECURE_PLUS_FEATURES,
  GET_BUNDLE_PRICING_INFO,
} from './config/url';

// eslint-disable-next-line import/prefer-default-export
export function productListFetch(params) {
  return doPostFetch(GET_PRODUCT_DETAILS, params, null);
}

// eslint-disable-next-line import/prefer-default-export
export function addItemCart(params) {
  // params = {IsCustomizable: "0", PfId: "ENV-08", SKU: "229-00050"};
  return doPostFetch(POST_PRODUCT_DETAILS, params, null);
}

// eslint-disable-next-line import/prefer-default-export
export function productListGetData() {
  return doGetFetch(GET_PRODUCT_INFO);
}

export function addToCart(params, successCallBack, errorCallBack) {
  console.log('Addtocart data');
  // params = {IsCustomizable: "0", PfId: "ENV-08", SKU: "229-00050"};
  doPostFetch(POST_PRODUCT_DETAILS, params, null)
    .then(() => {
      getPageConfigInfo(successCallBack, errorCallBack);
    })
    .catch((err) => {
      if (errorCallBack) errorCallBack(`productDataService -> addToCart failed. Error: ${err}`);
      console.log('Add to cart Issue:', 'error');
    });
}

export function getSecurePlusProductFeatures() {
  return doGetFetch(GET_SECURE_PLUS_FEATURES, {}, null, null, 'text/html');
}

export function getBundlePricingInfo(pf_id) {
  const params = {
    pf_id,
  };
  return doGetFetch(GET_BUNDLE_PRICING_INFO, params);
}
